import axios from "axios";
import cookie from "react-cookies";
import CryptoJS from 'crypto-js';
import { handleDecrypets } from "../library/decryptes";

const BASE_URL = process.env.REACT_APP_API_MAIN_SERVICE;
const OCR_V3_URL = process.env.REACT_APP_OCR_V3_URL;
const OCR_NEW_URL = process.env.REACT_APP_OCR_NEW_URL;
const REACT_APP_SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const REACT_APP_API_NOTIFICATION_SECRET_KEY = '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';

function getToken() {
  return cookie.load("token");
}

export const dummyTokenUpload =
  "eyJhY2NvdW50X3R5cGUiOiIzYjZiMjIwYi0yMDE5LTQyNzktODM0My1jYmU2MTY3Zjc2MDIiLCJlbWFpbCI6ImR3aXN0YXJpMTZAZ21haWwuY29tIiwiZXhwIjoxNjE0MTQ2NDQ3";


//const baypAssProxy = "https://cors-anywhere.herokuapp.com/";

export const serviceWithToken = (token = getToken()) =>
  axios.create({
    baseURL: BASE_URL,
    timeout: 60 * 4 * 1000,
    headers: {
      Authorization: "Bearer " + token,
    },
  });

export const serviceOcrUpload = (token = getToken()) =>
  axios.create({
    baseURL: OCR_NEW_URL,
    // timeout: 60 * 4 * 1000,
    headers: {
      Authorization: "Bearer " + token,
      // 'x-api-key': 'nd1CvmAfMR3qo5gkFhSr9x5gr1y7PvlabjFHXmvi'
    },
  });

export const serviceOcrUploadV3 = (token = getToken()) =>
  axios.create({
    baseURL: OCR_V3_URL,
    // timeout: 60 * 4 * 1000,
    headers: {
      Authorization: "Bearer " + token,
      // 'x-api-key': 'nd1CvmAfMR3qo5gkFhSr9x5gr1y7PvlabjFHXmvi'
    },
  });

export const serviceUploadWithToken = () =>
  axios.create({
    baseURL: BASE_URL,
    timeout: 60 * 4 * 1000,
    headers: {
      token: dummyTokenUpload,
      "Content-Type": `application/json`,
    },
  });

export const serviceWithoutToken = () =>
  axios.create({
    baseURL: BASE_URL,
    timeout: 60 * 4 * 1000,
    headers: {
      "Content-Type": `application/json`,
    },
  });

  export const serviceWithSignature = () => {
    let now = new Date();
    // Get timezone diff
    let timestamp = "Y-m-dTH:i:s+0700"
    let timezone = now.getTimezoneOffset() / 60 * -1
    let timeStr = timezone.toString().padStart(2, "0")
    let isMinus = '+'
    if (timeStr.includes("-")) {
      isMinus = '-'
      timeStr.replace("-", "")
    }
        
    let hour = timeStr.toString().replace("-", "").split(".")[0].padStart(2, "0")
    let minutes
  
    if (timeStr.toString().split(".")[1]) {
        let value = timeStr.toString().split(".")[1]
        if (value === '5') {
        minutes = timeStr.toString().split(".")[1] * 6
        } else if (value === '75') {
        minutes = '45'
      }
    } else {
      minutes = "00"
    }
  
    timestamp = timestamp.replace("Y", now.getFullYear().toString().padStart(4, "0"));
    timestamp = timestamp.replace("m", (now.getMonth()+1).toString().padStart(2, "0"));
    timestamp = timestamp.replace("d", now.getDate().toString().padStart(2, "0"));
    timestamp = timestamp.replace("H", now.getHours().toString().padStart(2, "0"));
    timestamp = timestamp.replace("i", now.getMinutes().toString().padStart(2, "0"));
    timestamp = timestamp.replace("s", now.getSeconds().toString().padStart(2, "0"));
    timestamp = timestamp.replace("+", isMinus)
    timestamp = timestamp.replace("07", hour);
    timestamp = timestamp.replace("00", minutes);
  
    let timestampUTC = "YmdHis";
    timestampUTC = timestampUTC.replace("Y", now.getUTCFullYear().toString().padStart(4, "0"));
    timestampUTC = timestampUTC.replace("m", (now.getUTCMonth()+1).toString().padStart(2, "0"));
    timestampUTC = timestampUTC.replace("d", now.getUTCDate().toString().padStart(2, "0"));
    timestampUTC = timestampUTC.replace("H", now.getUTCHours().toString().padStart(2, "0"));
    timestampUTC = timestampUTC.replace("i", now.getUTCMinutes().toString().padStart(2, "0"));
    timestampUTC = timestampUTC.replace("s", now.getUTCSeconds().toString().padStart(2, "0"));
  
    const localStorageData = JSON.parse(localStorage.getItem("security_answer"));
    const { empat, dua, tiga, lima } = localStorageData && localStorageData;
    const account_type = lima
    
    let cred = ''
    switch (account_type) {
      case 'business':
      case 'partner':
        cred = handleDecrypets(empat)
        break;
      case 'personal':
       cred = handleDecrypets(dua) + handleDecrypets(tiga)
        break;
      default:
        cred = handleDecrypets(empat)
        break;
    }
  
    // let secret_key = REACT_APP_SECRET_KEY;
    let receipt = `[send-otp:${timestampUTC}]:${cred}`;
    let hash = CryptoJS.HmacSHA256(receipt, REACT_APP_SECRET_KEY).toString()
  
    return axios.create({
      baseURL: BASE_URL,
      timeout: 60 * 4 * 1000,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Koinworks-Timestamp': timestamp,
        'X-Koinworks-Signature': hash
      }
    });
  }

  export const serviceRegisterOtp = () => {
    const { email } = JSON.parse(localStorage.getItem("dataRegister"));
    let now = new Date();
    
    // Get timezone diff
    let timestamp = "Y-m-dTH:i:s+0700"
    let timezone = now.getTimezoneOffset() / 60 * -1
    let timeStr = timezone.toString().padStart(2, "0")
    let isMinus = '+'
    if (timeStr.includes("-")) {
      isMinus = '-'
      timeStr.replace("-", "")
    }
  
    let hour = timeStr.toString().replace("-", "").split(".")[0].padStart(2, "0")
    let minutes
  
    if (timeStr.toString().split(".")[1]) {
      let value = timeStr.toString().split(".")[1]
      if (value === '5') {
        minutes = timeStr.toString().split(".")[1] * 6
      } else if (value === '75') {
        minutes = '45'
      }
    } else {
      minutes = "00"
    }
  
    timestamp = timestamp.replace("Y", now.getFullYear().toString().padStart(4, "0"));
    timestamp = timestamp.replace("m", (now.getMonth()+1).toString().padStart(2, "0"));
    timestamp = timestamp.replace("d", now.getDate().toString().padStart(2, "0"));
    timestamp = timestamp.replace("H", now.getHours().toString().padStart(2, "0"));
    timestamp = timestamp.replace("i", now.getMinutes().toString().padStart(2, "0"));
    timestamp = timestamp.replace("s", now.getSeconds().toString().padStart(2, "0"));
    timestamp = timestamp.replace("+", isMinus)
    timestamp = timestamp.replace("07", hour);
    timestamp = timestamp.replace("00", minutes);
  
    let timestampUTC = "YmdHis";
    timestampUTC = timestampUTC.replace("Y", now.getUTCFullYear().toString().padStart(4, "0"));
    timestampUTC = timestampUTC.replace("m", (now.getUTCMonth()+1).toString().padStart(2, "0"));
    timestampUTC = timestampUTC.replace("d", now.getUTCDate().toString().padStart(2, "0"));
    timestampUTC = timestampUTC.replace("H", now.getUTCHours().toString().padStart(2, "0"));
    timestampUTC = timestampUTC.replace("i", now.getUTCMinutes().toString().padStart(2, "0"));
    timestampUTC = timestampUTC.replace("s", now.getUTCSeconds().toString().padStart(2, "0"));
  
    const receipt = `[send-otp:${timestampUTC}]:${email}`;
    const hash = CryptoJS.HmacSHA256(receipt, REACT_APP_SECRET_KEY).toString()
    
    return axios.create({
      baseURL: BASE_URL,
      timeout: 60 * 4 * 1000,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "X-Koinworks-Signature": hash,
        "X-Koinworks-Timestamp": timestamp,
      }
    })
  }
